export default __webpack_public_path__ + "static/media/parmegiana@2x.5f65cd28.jpg";